import VendorTypeField from "kinnect-front/FacilityMaintenance/VendorTypes/VendorTypeField";
import { FacilityMaintenanceVendorType } from "kinnect-models";
import { FetchesData } from "kinnect-mixins";
import {
	KForm,
	KTextField
} from "kinnect-general";

export default KForm.extend( {
	name: "FacilityMaintenanceVendorForm",

	props: {
		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "facilityMaintenanceVendors" } ]
		},

		vendor: Object
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			idVendorType: null,
			name: null
		},
		vendorTypes: []
	} ),

	computed: {
		editing() {
			return Boolean( this.vendor );
		},

		formUrl() {
			return this.editing
				? `facility-maintenance/vendors/${this.vendor.id}`
				: "facility-maintenance/vendors";
		}
	},

	watch: {
		vendor: {
			handler( vendor ) {
				if ( vendor ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( vendor.hasOwnProperty( key ) ) {
							this.formFields[key] = vendor[key];
						}
					} );
				}
			},
			immediate: true
		}
	},

	methods: {
		onCreateVendorType( vendorType ) {
			this.vendorTypes.push( vendorType );
			this.formFields.idVendorType = vendorType.id;
		},

		async fetchVendorTypes() {
			this.vendorTypes = await FacilityMaintenanceVendorType.get();
		},

		async fetch() {
			await this.fetchVendorTypes();
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<VendorTypeField
				items={this.vendorTypes}
				label="Category*"
				loading={this.$wait.is( "get vendor categories" )}
				onCreate={this.onCreateVendorType}
				required
				showAddButton={this.$can( "add_facility_maintenance_vendor_types" )}
				vModel={this.formFields.idVendorType}
				validationName="vendor category"
				validationRules="required"
			></VendorTypeField>
		</KForm>;
	}
} );
